import React from "react";

function CollapseView({
  raw,
  onEdit,
  onView,
  onPartialReceive,
  onReceive,
  onDelete,
}) {
  const [open, setOpen] = React.useState(false);
  const triggerRef = React.useRef(null);
  const menuRef = React.useRef(null);

  React.useEffect(() => {
    const handleDown = (e) => {
      if (!open) return;
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    const handleKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", handleDown);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleDown);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>DR #:</strong> {raw?.["dr#"]}
        </p>
        <p className="mb-1">
          <strong>DR Type:</strong> {raw?.drType}
        </p>
        <p className="mb-1">
          <strong>Date Created:</strong>{" "}
          {new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          }).format(new Date(raw?.created))}
        </p>
        <p className="mb-1">
          <strong>Created By:</strong> {raw?.createdBy?.email}
        </p>
        <p className="mb-1">
          <strong>Date Updated:</strong>{" "}
          {new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          }).format(new Date(raw?.updated))}
        </p>
        <p className="mb-1">
          <strong>Updated By:</strong> {raw?.updatedBy?.email ?? "N/A"}
        </p>
      </div>

      <div className="d-flex gap-2 align-items-center">
        {raw?.status === "Draft" && (
          <button className="btn btn-success text-white" onClick={onEdit}>
            <i className="bi bi-pencil-fill me-2"></i> Edit
          </button>
        )}
        {raw?.status === "Partially Receive" && (
          <button className="btn btn-success text-white" onClick={onEdit}>
            Receive
          </button>
        )}

        <button
          className="btn"
          onClick={onView}
          style={{ backgroundColor: "#d1d1d1" }}
        >
          <i className="bi bi-eye me-2"></i> View
        </button>

        {/* three-dots + popover */}
        <div className="position-relative">
          {/* <button
            ref={triggerRef}
            type="button"
            className="btn p-1"
            aria-label="More actions"
            aria-expanded={open}
            aria-haspopup="menu"
            onClick={() => setOpen((v) => !v)}
          >
            <i
              className="bi bi-three-dots-vertical fw-bold"
              style={{ color: "black", fontSize: "20px" }}
            />
          </button> */}

          {open && (
            <div
              ref={menuRef}
              role="menu"
              className="shadow rounded p-2"
              style={{
                position: "absolute",
                top: "50%",
                left: "calc(100% + 8px)", // right side of the icon
                transform: "translateY(-50%)",
                zIndex: 1050,
                width: 200,
                background: "#fff",
              }}
            >
              <button
                className="btn w-100 fw-semibold mb-2"
                style={{ background: "#FFCC33", color: "#000" }}
                onClick={() => {
                  setOpen(false);
                  onPartialReceive();
                }}
              >
                Partially Receive
              </button>

              {raw?.status === "Draft" && (
                <>
                  <button
                    className="btn w-100 text-white fw-semibold mb-2"
                    style={{ background: "#82c14a" }}
                    onClick={() => {
                      setOpen(false);
                      onReceive();
                    }}
                  >
                    Receive
                  </button>

                  <button
                    className="btn w-100 text-white fw-semibold"
                    style={{ background: "#E4573D" }}
                    onClick={() => {
                      setOpen(false);
                      onDelete();
                    }}
                  >
                    <i className="bi bi-trash me-2" />
                    Delete
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CollapseView;
